/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20012FormativeAction model module.
 * @module model/InlineResponse20012FormativeAction
 * @version 1.0.0
 */
class InlineResponse20012FormativeAction {
    /**
     * Constructs a new <code>InlineResponse20012FormativeAction</code>.
     * @alias module:model/InlineResponse20012FormativeAction
     */
    constructor() { 
        
        InlineResponse20012FormativeAction.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012FormativeAction</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012FormativeAction} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012FormativeAction} The populated <code>InlineResponse20012FormativeAction</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012FormativeAction();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20012FormativeAction.prototype['id'] = undefined;

/**
 * @member {String} title
 */
InlineResponse20012FormativeAction.prototype['title'] = undefined;

/**
 * @member {String} code
 */
InlineResponse20012FormativeAction.prototype['code'] = undefined;






export default InlineResponse20012FormativeAction;

